import { getConfigFieldsCrud, getConfigVoucher, searchProviders } from 'actions'
import {
	pricesAndCostsApply,
	pricesAndCostsCalculate,
	pricesAndCostsClean,
	pricesAndCostsConfirm,
	pricesAndCostsNewValue,
	pricesAndCostsPaginate,
	pricesAndCostsVerify
} from 'actions/PricesAndCostsMassiveUploadActions'
import { P_PRICES_AND_COSTS_MASSIVE_UPLOAD } from 'constants/ConfigProcessNames'
import { getFiltersData } from 'lib/Utils'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
	IPricesAndCostsApply,
	IPricesAndCostsCalculate,
	IPricesAndCostsConfirm,
	IPricesAndCostsMassiveUploadProps,
	IPricesAndCostsMassiveUploadState,
	IPricesAndCostsVerify
} from '../../models/PricesAndCostsMassiveUploadInterface'
import PricesAndCostsMassiveUploadFilter from './PricesAndCostsMassiveUploadFilter'
import PricesAndCostsMassiveUploadForm from './PricesAndCostsMassiveUploadForm'
import PricesAndCostMassiveUploadTable from './PricesAndCostsMassiveUploadTable'

class PricesAndCostsMassiveUpload extends Component<
	IPricesAndCostsMassiveUploadProps,
	IPricesAndCostsMassiveUploadState
> {
	constructor(props: IPricesAndCostsMassiveUploadProps) {
		super(props)
		this.state = {
			idOperacion: props.idOperacion || 0,
			disableForm: false,
			gridProdList: {
				lista: []
			},
			paramsSearch: {
				idOperacion: props.idOperacion || 0,
				page_size: 10,
				page_number: 1,
				niprod: 0
			},
			isSearching: false,
			niProv: '',
			errorMessage: '',
			showVerificationModal: false,
			verificationResult: null,
			calculatedResults: {},
			valuesToCalculate: {}
		}
	}

	componentDidUpdate = (prevProps: IPricesAndCostsMassiveUploadProps) => {
		const {
			pricesAndCostsApplied,
			pricesAndCostsPagination,
			pricesAndCostsCalculated,
			pricesAndCostsVerified,
			idOperacion,
			pricesAndCostsConfirm
		} = this.props

		const {
			pricesAndCostsApplied: prevPricesAndCostsApplied,
			pricesAndCostsPagination: prevPricesAndCostsPagination,
			pricesAndCostsCalculated: prevPricesAndCostsCalculated,
			pricesAndCostsVerified: prevPricesAndCostsVerified
		} = prevProps
		const { niProv } = this.state

		if (
			prevPricesAndCostsVerified !== pricesAndCostsVerified &&
			pricesAndCostsVerified
		) {
			if (pricesAndCostsVerified.Resultado.Resultado === true) {
				const values = {
					idOperacion: idOperacion || 0,
					niprov: niProv || ''
				}
				pricesAndCostsConfirm(values)
			} else {
				this.setState({
					errorMessage: pricesAndCostsVerified.Resultado.Mens_error,
					showVerificationModal: true
				})
			}
		}
		if (
			prevPricesAndCostsApplied !== pricesAndCostsApplied &&
			pricesAndCostsApplied
		) {
			this.setState({
				gridProdList: { ...pricesAndCostsApplied }
			})
		}
		if (
			prevPricesAndCostsPagination !== pricesAndCostsPagination &&
			pricesAndCostsPagination
		) {
			this.setState({
				gridProdList: { ...pricesAndCostsPagination }
			})
		}
		if (
			prevPricesAndCostsCalculated !== pricesAndCostsCalculated &&
			pricesAndCostsCalculated
		) {
			this.setState({
				gridProdList: { ...pricesAndCostsCalculated }
			})
		}
	}

	handleFilterApply = (values: IPricesAndCostsApply) => {
		const { pricesAndCostsApply, idOperacion } = this.props
		const newFilters = {
			...values,
			idOperacion: idOperacion || 0,
			page_size: values.page_size,
			page_number: values.page_number
		}

		const updateNiprov = values.lk_prove ?? ''

		this.setState({
			niProv: updateNiprov
		})

		pricesAndCostsApply(newFilters)
	}

	handleCalculate = (values: IPricesAndCostsCalculate) => {
		const { pricesAndCostsCalculate, idOperacion } = this.props
		const newValues = {
			...values,
			idOperacion: idOperacion || 0
		}
		pricesAndCostsCalculate(newValues)
		this.setState({ valuesToCalculate: newValues })
	}

	handleChange = (type: string, row: number, value: number) => {
		const { pricesAndCostsNewValue, idOperacion } = this.props
		const { valuesToCalculate } = this.state

		if (type === 'price') {
			pricesAndCostsNewValue({
				idOperacion: idOperacion || 0,
				dato: valuesToCalculate.dato,
				pc: valuesToCalculate.pc,
				niprod: row,
				nuevo_valor: value
			})
		}
	}

	handleChangeTable = (type: String, pagination: any, value: any) => {
		const { paramsSearch } = this.state
		const { pricesAndCostsPaginate, idOperacion } = this.props
		if (type === 'pagination') {
			pricesAndCostsPaginate({
				...paramsSearch,
				idOperacion: idOperacion || 0,
				page_size: pagination.sizePerPage,
				page_number: pagination.page
			})
		}
		if (type === 'input') {
			this.handleChange('price', value.rowId, value.value)
		}
	}

	handleButtonClean = () => {
		this.setState({
			disableForm: false,
			gridProdList: {
				lista: []
			},
			paramsSearch: {
				idOperacion: this.props.idOperacion || 0,
				page_size: 10,
				page_number: 1,
				niprod: 0
			},
			calculatedResults: {},
			valuesToCalculate: {}
		})

		this.props.pricesAndCostsClean()
	}

	handleVerify = (values: IPricesAndCostsVerify) => {
		const { pricesAndCostsVerify, idOperacion } = this.props
		pricesAndCostsVerify(idOperacion || 0)
	}

	handleConfirm = (values: IPricesAndCostsConfirm) => {
		const { pricesAndCostsConfirm, idOperacion } = this.props
		const val = {
			idOperacion: idOperacion || 0
		}
		pricesAndCostsConfirm(val)
	}

	handleClosePopup = () => {
		this.setState({ showVerificationModal: false })
	}

	handleSearchProviders = (value: any) => {
		this.props.searchProviders({ criterio_proveedor: value })
		this.handleIsSearching(true)
	}

	handleIsSearching = (isSearching: boolean) => {
		this.setState({ isSearching })
	}

	handleMapValues = (values: any) => {
		const { idOperacion } = this.props
		const apiPayload = {
			idOperacion: idOperacion || 0,
			page_size: 10,
			page_number: 1,
			lk_cod_prod: values.lk_cod_prod,
			lk_desc_prod: values.lk_desc_prod,
			lk_categ_prod: values.lk_categ_prod,
			lk_prove: values.niprov
		}
		this.handleFilterApply(apiPayload)
	}

	render() {
		const { config, t, idOperacion, listProviders, priceTypeData } = this.props
		const {
			disableForm,
			gridProdList,
			showVerificationModal,
			valuesToCalculate,
			errorMessage
		} = this.state

		const gridProdListArray: {
			cod_prod: any
			cod_barra: any
			desc_prod: any
			precio: any
			costo: any
			costo_pact: any
			costo_uc: any
			nuevo_valor: any
			niprod: any
		}[] = []

		const data = gridProdList

		data.lista.forEach(
			(item: {
				cod_prod: any
				cod_barra: any
				desc_prod: any
				precio: any
				costo: any
				costo_pact: any
				costo_uc: any
				nuevo_valor: any
				niprod: any
			}) => {
				const gridItem = {
					cod_prod: item.cod_prod,
					cod_barra: item.cod_barra,
					desc_prod: item.desc_prod,
					precio: item.precio,
					costo: item.costo,
					costo_pact: item.costo_pact,
					costo_uc: item.costo_uc,
					nuevo_valor: item.nuevo_valor,
					niprod: item.niprod
				}

				gridProdListArray.push(gridItem)
			}
		)

		const tableFields = config
			? getFiltersData(config.campos, { agrupador: 'grilla' })
			: []
		const filterFields = config
			? getFiltersData(config.campos, { agrupador: 'formulario' })
			: []

		const formFields = config
			? config.campos.filter((field: any) => {
					return field.agrupador.includes('principal')
			  })
			: []

		const filterProps = {
			fields: filterFields,
			t: t,
			disableForm: disableForm,
			handleFilterApply: this.handleFilterApply,
			handleButtonClean: this.handleButtonClean,
			handleMapValues: this.handleMapValues,
			handleIsSearching: this.handleIsSearching,
			handleSearchProviders: this.handleSearchProviders,
			isSearching: this.state.isSearching,
			listProviders: listProviders
		}

		const formProps = {
			fields: formFields,
			t: t,
			idOperacion: idOperacion,
			disableForm: disableForm,
			handleCalculate: this.handleCalculate,
			handleVerify: this.handleVerify,
			handleConfirm: this.handleConfirm,
			showVerificationModal: showVerificationModal,
			handleClosePopup: this.handleClosePopup,
			errorMessage: errorMessage
		}

		const tableProps = {
			idOperacion: idOperacion || 0,
			tableFields: [...tableFields],
			fields: gridProdList,
			gridProdListArray: gridProdListArray,
			t: t,
			disableForm: disableForm,
			handleChangeTable: this.handleChangeTable,
			valuesToCalculate: valuesToCalculate,
			priceTypeData: priceTypeData
		}

		return (
			<>
				<PricesAndCostsMassiveUploadFilter {...filterProps} />
				<PricesAndCostsMassiveUploadForm {...formProps} />
				<PricesAndCostMassiveUploadTable {...tableProps} />
			</>
		)
	}
}
const mapStateToProps = ({
	voucher,
	auth,
	configCrud,
	pricesAndCostsMassiveUpload,
	providers,
	tableCalls
}: any) => {
	const config = voucher.config
		? voucher.config[P_PRICES_AND_COSTS_MASSIVE_UPLOAD]
		: null

	const { fieldsConfig } = configCrud
	const { authUser } = auth
	const { listProviders } = providers
	const { priceTypeData } = tableCalls

	const {
		pricesAndCostsApplied,
		pricesAndCostsCalculated,
		pricesAndCostsConfirmed,
		pricesAndCostsPagination,
		pricesAndCostsVerified
	} = pricesAndCostsMassiveUpload

	return {
		config,
		authUser,
		fieldsConfig,
		pricesAndCostsApplied,
		pricesAndCostsCalculated,
		pricesAndCostsConfirmed,
		pricesAndCostsPagination,
		pricesAndCostsVerified,
		listProviders,
		priceTypeData
	}
}

const connectForm = connect(mapStateToProps, {
	getConfigVoucher,
	getConfigFieldsCrud,
	pricesAndCostsApply,
	pricesAndCostsCalculate,
	pricesAndCostsPaginate,
	pricesAndCostsClean,
	pricesAndCostsVerify,
	pricesAndCostsConfirm,
	pricesAndCostsNewValue,
	searchProviders
})(PricesAndCostsMassiveUpload)
export default withTranslation()(withRouter(connectForm))
